module.exports = __webpack_public_path__ + "img/whatsapp.a0367c96.svg";